module.exports = __webpack_public_path__ + "static/redime-tus-puntos-1-CL-39a91c7992848262ead5e7bf770f57ec.png";